'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = require('rp-react-svg-icon');

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoData = function NoData(_ref) {
  var text = _ref.text;
  return _react2.default.createElement(
    'div',
    { className: 'ui-errorMessage' },
    _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'results', size: '2XL' }),
    _react2.default.createElement(
      'div',
      { className: 'ui-errorMessage__text' },
      text
    )
  );
};

NoData.propTypes = {
  text: _propTypes2.default.string
};

exports.default = NoData;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-table/lib/RpTable/components/NoData.js
// module id = 930
// module chunks = 0